import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { AccountRouteParams } from './core/routeparams';

@Injectable()
export class SelectedAccountService {
  private selectedAccountId$$ = new ReplaySubject<string>(1);

  resolve(route: ActivatedRouteSnapshot): string | null {
    const accountId = (route.params as AccountRouteParams).accountGroupId;
    if (accountId) {
      this.selectedAccountId$$.next(accountId);
      return accountId;
    }
    return null;
  }

  public getAccountId(): Observable<string> {
    return this.selectedAccountId$$.pipe(distinctUntilChanged(), shareReplay());
  }
}
